import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { mobile, mobileM, tablet } from "../../responsive";
import "./styles.scss";
import { Search } from "@material-ui/icons";
//
//

//
import Aos from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";

const SearchContainer = styled.div`
  //
  //
  width: 100%;

  .searchInput {
    display: flex;
    justify-content: center;
    .fas,
    .IconSearch {
      opacity: 0.3;
      color: #272727f8;
      cursor: pointer;
    }
  }
`;

//
const WrapperProducts = styled.div`
  width: 100%;
`;
//
const GallerySearchContainer = styled.div`
  //
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  //
  position: absolute;
  top: 100%;
  //bg dropdown result search
  background-color: rgb(248, 248, 248);
  /* background: #e9e50078; */
  //
  width: 100vw;
  min-height: 100vh;
  padding: 3vh 0;

  ::-webkit-scrollbar {
    display: none;
  }
  ${mobile({
    flexDirection: "column",
    backgroundColor: "rgb(248, 248, 248)",
    margin: "0 0 0 0",
    overflow: "hidden",
    overflowY: "auto",
  })}
  ${mobileM({
    flexDirection: "column",
    backgroundColor: "rgb(248, 248, 248)",
    margin: "0 0 0 0",
    overflow: "hidden",
    overflowY: "auto",
  })}
    ${tablet({
    flexDirection: "column",
    backgroundColor: "rgb(248, 248, 248)",
    margin: "0 0 0 0",
    overflow: "hidden",
    overflowY: "auto",
  })}
`;

//
const Card = styled.div`
  width: 100%;
  padding: 0.2em;
  grid-template-columns: repeat(2, 1fr);
  display: grid;
  grid-gap: 0.5em;

  //
  .links-searchBar {
    color: #6b341071;
  }
  //
  //
  ${mobile({
    padding: "1em ",
    display: "grid",
    gridGap: "0.1em",
    gridTemplateColumns: "repeat(3, 1fr)",
  })}
  ${mobileM({
    padding: "1em ",
    display: "grid",
    gridGap: "0.1em",
    gridTemplateColumns: "repeat(3, 1fr)",
  })}
`;
//

const P = styled.p`
  font-size: calc(8px + 1vmin);
  text-transform: lowercase;
  color: #27272773;
  font-family: "Poppins-Light";
  font-weight: 600;
`;

//
//
const CardImgBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  img {
    width: 100%;
    min-height: auto;
    object-fit: cover;
  }

  ${mobile({
    width: "90%",
  })}
`;
//
//
//
const Input = styled.input`
  margin: 0 10px 0 0;
  padding: 5px 26px;
  background-color: #ececec14;
  border-radius: 5em;
  border: 0;
  font-size: calc(7px + 1vmin);
  color: #272727f8;
  ${mobile({
    padding: "5px 0 5px 7px",
    margin: "0 2px 0 20px",
  })}
  ${mobileM({
    padding: "5px 0 5px 7px",
    margin: "0 2px 0 20px",
  })}

  /* */

  ::placeholder {
    color: #27272750;
    opacity: 1; /* Firefox */
  }
  &:focus {
    outline: none;
    background-color: #f3f3f34e;
    color: #272727f8;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #272727f8;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #8741125e;
  }
`;
//
//

const SearchBar = ({ placeholder, data }) => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  //
  const [filterData, setFilterData] = useState([]);
  const [wordEntered, setWordEntered] = useState([]);
  //
  //
  //
  const handleFilter = (event) => {
    event.preventDefault();
    const searchWord = event.target.value;

    setWordEntered(searchWord);
    const newFilter = data.filter((value) => {
      //
      return value.category.toLowerCase().includes(searchWord.toLowerCase());
    });
    //
    //

    if (searchWord === "") {
      setFilterData([]);
    } else {
      setFilterData(newFilter);
    }
    //
  };
  //
  //

  const removeItem = () => {
    setFilterData([]);
    // 4
    setWordEntered("");
  };
  //
  return (
    <>
      {" "}
      <SearchContainer>
        <div className="searchInput">
          <Input
            type="text"
            placeholder={placeholder}
            onChange={handleFilter}
            value={wordEntered}
          />

          {filterData.length === 0 ? (
            <Search className="IconSearch" />
          ) : (
            <i className="fas fa-times" onClick={removeItem}></i>
          )}
        </div>{" "}
      </SearchContainer>{" "}
      <WrapperProducts>
        {filterData.length !== 0 && (
          <GallerySearchContainer>
            {filterData.slice(0, 3).map((value) => {
              return (
                <>
                  <div key={value.id}>
                    {" "}
                    <Card>
                      <CardImgBox>
                        <Link to={`/product/${value._id}`}>
                          <motion.img
                            data-aos="fade-right"
                            src={value.image}
                            alt={value.name}
                          />
                        </Link>
                      </CardImgBox>
                      <Link
                        to={`/product/${value._id}`}
                        className="links-searchBar"
                      >
                        <P>{value.name}</P>
                      </Link>
                    </Card>
                  </div>
                </>
              );
            })}
          </GallerySearchContainer>
        )}
      </WrapperProducts>
    </>
  );
};

export default SearchBar;
